export { default as GlobalConsentBanner } from './GlobalConsentBanner';
